import React, { useEffect } from "react";
import { Provider } from "react-redux";
import store from "store";
import { QueryClient, QueryClientProvider } from "react-query";
import Auth from "services/auth";
import { GA_pageView, GA_init } from "services/analytics";
import { bestPriceCoins } from "store/reducers/bestPriceCoins";
import { tokens } from "store/reducers/tokenStore";
import HomeRoute from "./router/index";
import "i18n/index";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/styles/_globals.scss";

const queryClient = new QueryClient();
function App() {
  const userInfo = store.getState().user.userInfo;
  useEffect(() => {
    const authInstance = new Auth();
    try {
      authInstance.updateUserInfo();
      store.dispatch(bestPriceCoins());
      store.dispatch(tokens());
    } catch (e) {
      console.log("E", e);
    }
  }, [userInfo]);

  // Mounting App
  useEffect(() => {
    GA_init();
    GA_pageView();
  }, []);
  return (
    <>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <HomeRoute />
        </QueryClientProvider>
      </Provider>
    </>
  );
}

export default App;
